import { FooterLink } from 'src/shared/models/footer-link';
import { UserRole } from 'src/modules/security/enums/user-role.enum';
import { AppRouteEnum } from 'src/app/enums/app-route.enum';

export const footerLinks: FooterLink[] = [
  {
    name: 'Support',
    url: `/${AppRouteEnum.Support}`,
    loginRequired: false
  },
  {
    name: 'Phlebotomy',
    loginRequired: true,
    userType: UserRole.Phlebotomy
  },
  {
    name: 'Forms',
    loginRequired: true
  },
  {
    name: 'Downloads',
    loginRequired: true
  }
];
